import React, { useState, useEffect } from 'react'
import Navbar from '../../components/Navbar'
import PreNav from '../../components/PreNav'
import Footer from '../../components/Footer'
import AddAddress from '../../components/Address/AddAddress'
import {getUserAddresses} from "../../redux/actions/addressAction"
import { useDispatch, useSelector } from 'react-redux'
import Loader from '../../components/util/Loader'
import { useNavigate } from 'react-router-dom'
import Toaster from '../../components/util/Toaster'
import { createOrder } from '../../redux/actions/orderAction'

const Checkoute = () => {

  const navigate = useNavigate()
  const dispatch = useDispatch()
  const [items, setItems] = useState([])
  const {addresses} = useSelector(state=>state.address)
  const [loading, setLoading] = useState(true)
  const [selectedAddress, setSelectedAddress] = useState()
  const [subTotalPrice, setSubTotalPrice] = useState(0)
  const [shippingPrice, setShippingPrice] = useState(0)
  const [isDissabled, setisDissabled] = useState(true)
  const [shippingType, setShippingType] = useState("standard")
  const [orderLoading, setOrderLoading] = useState(false)
  // toaster states
  const [toaster, setToaster] = useState(false);
  const [message, setMessage] = useState("")

  useEffect(() => {
    const checkoutItems = JSON.parse(localStorage.getItem("checkoutItems"))
    if (checkoutItems.length === 0) {
      navigate("/")
    } else {
      setItems(checkoutItems)
    }
  }, [])

  useEffect(() => {
    subTotalPriceHandler()
  }, [items])
  
  useEffect(() => {
    if (addresses.length === 0) {
      dispatch(getUserAddresses())
      .then(res=>{
        setLoading(false)
      })
    }
  }, [])

  useEffect(() => {
    if (addresses.length > 0 && !selectedAddress) {
      setSelectedAddress(addresses[0])
    }
  }, [loading, addresses])

  useEffect(() => {
    if (selectedAddress) {
      setisDissabled(false)
    }
  }, [selectedAddress])

  const subTotalPriceHandler = () => {
    let total = 0
    items.map((item)=>{
      total += (item.variant_price * item.quantity)
    })
    setSubTotalPrice(total)
  }

  const handleShipping = (value) => {
    setShippingType(value)
    if (value === "express") {
      setShippingPrice(99)
    } else {
      setShippingPrice(0)
    }
  }

  const itemArrayHandler = () => {
    let newItems = []
    items.forEach(element => {
      const neededItemDetails = {
        name: element.title,
        handle: element.handle,
        price: element.variant_price,
        quantity: element.quantity,
        image: element.variant_image,
        itemId: element._id,
        option1_name: element.option1_name,
        option1_value: element.option1_value,
        option2_name: element.option2_name,
        option2_value: element.option2_value,
      }
      newItems.push(neededItemDetails)
    });
    return newItems
  }

  const handlePlaceOrder = () => {
    setOrderLoading(true)
    const neededItems = itemArrayHandler()
    const data = {
      shippingInfo: {
        name: selectedAddress.name,
        address: selectedAddress.address,
        pinCode: selectedAddress.pinCode,
        state: selectedAddress.state,
        country: selectedAddress.country,
        phoneNumber: selectedAddress.phoneNumber,
      },
      orderItems: neededItems,
      user: selectedAddress.user._id,
      paymentInfo: {
        payment_id:"paymentPending",
        status:"Pending",
        paidAt: Date.now()
      },
      itemsPrice: subTotalPrice,
      shippingPrice: shippingPrice,
      taxPrice: 0,
      totalPrice: subTotalPrice + shippingPrice,
      orderStatus: "Placed"
    }
    dispatch(createOrder(data))
    .then(res=>{
        console.log(res)
        setOrderLoading(false)
        if (res.success) {
          navigate(`/payments/${res.order._id}`)
        } else {
          handleToaster(res.message)
        }
    })
  }

  const handleToaster = (message) => {
    setToaster(true)
    setMessage(message)
    setTimeout(() => {
      setToaster(false)
      setMessage("")
    }, 5000);
  }

  return (
    <>
    <PreNav/>
    <Navbar/>
        <nav className="py-5">
      <div className="container">
        <div className="row">
          <div className="col-12">
            <ol className="breadcrumb mb-md-0 font-size-xs text-gray-400">
              <li className="breadcrumb-item">
                <a className="text-gray-400" href="/">Home</a>
              </li>
              <li className="active">
                <i className='bi bi-chevron-right px-3'></i>
                Checkout
              </li>
            </ol>
          </div>
        </div>
      </div>
    </nav>
    <section className='pt-7 pb-12'>
      <div className="container">
        <div className="row">
          <div className="col-12">
            {/* Heading */}
            <h3 className="mb-10 text-center">Checkout</h3>
          </div>
        </div>
        <div className="row">
          <div className="col-12 col-md-7">
            <h6>Select your address</h6>
            <div className="row">
              {loading ? <Loader/> : <>{addresses.length > 0 ? addresses.map((item, index)=>(
                <div className="col-12 col-lg-6" key={index} onClick={()=>setSelectedAddress(item)}>
                  <div className="card card-lg bg-light mb-8 cursor-pointer">
                    <div className="card-body">
                      {/* Heading */}
                      <h6 className="mb-6">
                        Shipping Address
                      </h6>
                      {/* Text */}
                      <p className="text-muted mb-0">
                        {item.name} <br />
                        {item.address}, {item.pinCode} <br />
                        {item.state}, {item.country} <br />
                        {item.phoneNumber} <br />
                      </p>
                    </div>
                {selectedAddress === item && <div className="card-action card-action-right">
                  <a className="btn btn-xs btn-circle btn-primary mr-2 text-white font-size-lg"><i className="bi bi-check" /></a>
                </div>}
                  </div>
                </div>
              )) : <p className='col-12'>No saved address found. Please enter you address in order to proceed.</p>}
              <div className="col-12">
              <button data-toggle="modal" href="#addAddressModal" className="btn btn-block btn-lg btn-outline-border">Add Address <i className="bi bi-plus" /></button>
              </div></>}
              {/* shipping details */}
                <div className="col-12 mt-8">
                <h6>Shipping Details</h6>
            <div className="table-responsive mb-6">
        <table className="table table-bordered table-sm table-hover mb-0">
          <tbody>
            <tr>
              <td>
                <div className="custom-control custom-radio">
                  <input className="custom-control-input" id="checkoutShippingStandard" name="shipping" type="radio" value="standard" checked={shippingType==="standard"} onClick={()=>handleShipping("standard")}/>
                  <label className="custom-control-label text-body text-nowrap" htmlFor="checkoutShippingStandard">
                    Standard Shipping
                  </label>
                </div>
              </td>
              <td>Delivery in 5 - 7 working days</td>
              <td>Free</td>
            </tr>
            <tr>
              <td>
                <div className="custom-control custom-radio">
                  <input className="custom-control-input" id="checkoutShippingExpress" name="shipping" type="radio"  value="express" checked={shippingType==="express"} onClick={()=>handleShipping("express")} />
                  <label className="custom-control-label text-body text-nowrap" htmlFor="checkoutShippingExpress">
                    Express Shipping
                  </label>
                </div>
              </td>
              <td>Delivery in 3 - 5 working days</td>
              <td>Rs. 99</td>
            </tr>
          </tbody>
        </table>
            </div>
                </div>
            </div>
          </div>
          <div className="col-12 col-md-5 col-lg-4 offset-lg-1">
        {/* Heading */}
        <h6 className="mb-7">Order Items ({items.length})</h6>
        {/* Divider */}
        <hr className="my-7" />
        {/* List group */}
        <ul className="list-group list-group-lg list-group-flush-y list-group-flush-x mb-7">
          {items.map((item, index)=>(
            <li className="list-group-item" key={index}>
            <div className="row align-items-center">
              <div className="col-4">
                <a href="product.html">
                  <img src={item.variant_image} alt="..." className="img-fluid" />
                </a>
              </div>
              <div className="col">
                <p className="mb-4 font-size-sm font-weight-bold">
                  <a className="text-body" href={`/collections/framed-art/products/${item.handle}`}>{item.title}</a> <br />
                  <span className="text-muted">Rs. {item.variant_price}</span>
                </p>
                {/* Text */}
                <div className="font-size-sm text-muted">
                  {item.option1_name}: {item.option1_value} <br />
                  {item.option2_name}: {item.option2_value}
                </div>
              </div>
            </div>
          </li>
          ))}
        </ul>
        {/* Card */}
        <div className="card mb-9 bg-light">
          <div className="card-body">
            <ul className="list-group list-group-sm list-group-flush-y list-group-flush-x">
              <li className="list-group-item d-flex">
                <span>Subtotal</span> <span className="ml-auto font-size-sm">Rs {subTotalPrice}</span>
              </li>
              <li className="list-group-item d-flex">
                <span>Shipping</span> <span className="ml-auto font-size-sm">Rs {shippingPrice}</span>
              </li>
              <li className="list-group-item d-flex font-size-lg font-weight-bold">
                <span>Total</span> <span className="ml-auto">Rs {subTotalPrice + shippingPrice}</span>
              </li>
            </ul>
          </div>
        </div>
        {/* Disclaimer */}
        <p className="mb-7 font-size-xs text-gray-500">
          Your personal data will be used to process your order, support
          your experience throughout this website, and for other purposes
          described in our privacy policy.
        </p>
        {/* Button */}
        <button className="btn btn-block btn-dark" onClick={handlePlaceOrder} disabled={isDissabled} >{orderLoading ? <div className="spinner-border loader-sizing" style={{height:"1.5rem", width:"1.5rem"}} role="status"><span className="sr-only"></span></div>:"Place Order"}</button>
      </div>
        </div>
      </div>
    </section>
    <AddAddress/>
    {toaster && message && <Toaster text={message} timeout={5} icon={"X"} />}
    {/* <Toaster text={"Lorem ipsum dolor sit amet."} timeout={100000}/> */}
    <Footer/>
    </>
  )
}

export default Checkoute